/* eslint-disable */
import React, { Component } from 'react'
import { NavigationActions } from 'react-navigation'

import { forEach } from 'lodash'
import { Alert, ScrollView, KeyboardAvoidingView, SectionList, Image, Platform, View, ActivityIndicator, Linking, Dimensions } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import VersionNumber from 'react-native-version-number'
import I18n from "i18n-js"
//import * as RNLocalize from "react-native-localize"
//import ReactNativeVersion from '../../node_modules/react-native/Libraries/Core/ReactNativeVersion'

import { connect } from 'react-redux'
import { Images, Fonts } from '../Themes'

//import userDefaults from 'react-native-user-defaults'
import PostWallBase from './PostWallBase'

import SectionHeader from '../Components/SectionHeader';
import KargoeSelectorComponent from '../Components/KargoeSelectorComponent'
import SectionHeaderSettings from '../Components/SectionHeaderSettings';
import ListItemTextIcon from '../Components/ListItemTextIcon';
import ListItemArrowIcon from '../Components/ListItemArrowIcon';
import ListItemTextMiddle from '../Components/ListItemTextMiddle';
import BackButtonComponent from '../Components/BackButtonComponent';
import BaseScreen from './BaseScreen'
import MainNavBarScreen from './MainNavBarScreen'
import AuthActions from '../Redux/AuthRedux';
import UserActions from '../Redux/UserRedux';
// import StartupActions from '../Redux/StartupRedux';
import { OfflineMessaging } from '../Services/OfflineMessaging'
import styles from './Styles/SettingsScreenStyle'
import {isIPhoneX, humanReadableSpace, alertView, getDeviceLanguage} from '../Lib/utils'
import {
  SvgTouchId, SvgKargoeCare, SvgEditProfile, SvgDelivery, SvgPush,
  SvgKargoetagTheySellArrow, SvgHome, SvgCamera, SvgBurger, SvgClose, SvgDonate
} from '../Components/SvgComponent'
import {
  Container, Icon, Header,
  Content, ListItem, CheckBox,
  Thumbnail, Text, Left, Body,
  Right,
  Switch
} from 'native-base'
import {
  FAQURL,
  PRIVACYURL,
  TERMURL,
  IOSURL,
  ANDROIDURL,
  DELIVERYURL,
  LANG_SELECTOR,
  CURRENCY_SELECTOR,
} from '../Constant'
import API from '../Services/Api'
import { getLanguageCode } from '../I18n/I18n'
const screenDimensions = Dimensions.get('window')
const screenWidth = screenDimensions.width
const screenHeight = screenDimensions.height

class SettingsScreen extends Component {
  constructor(props) {
    super(props)
    this.onAboutScreenPressCount = 0
    console.tron.display({
      name: 'setting  screen',
      preview: 'constructor',
      value: {
        response: this.props
      }
    })
    this.state = {
      UserId: this.props.currUserId,
      ApplicationOptions: 0,
      userLoaded: false,
      editing: false,
      Modified: 0,
    }
    this.onToggle = this.onToggle.bind(this)
    this.componentDidUpdate = this.componentDidUpdate.bind(this)
    this.onContactSupportPress = this.onContactSupportPress.bind(this)
    this.onDebugScreen = this.onDebugScreen.bind(this)
    this.api = API.create()
  }

  resetRoute = (routeName, params) => {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: routeName, params: params })]
    }))
  }

  onDeliveryCellPress = () => {
    this.props.navigation.navigate('deliveryAddresses', {});
  }

  onSocialSharingPress = () => {
    this.props.navigation.navigate('socialSharing', {});
  }
  
  onContactSupportPress = async () => {
    const devInfoProps = Object.getOwnPropertyNames(DeviceInfo)
    console.tron.log(`onContactSupportPress prop names: ` + JSON.stringify(devInfoProps))
    let body = `\n\n\n=========================\nApplication & Device Details\nKargoe ${this.getVersionString()}\n`
    for (let functionName of devInfoProps) {
      console.tron.log(`onContactSupportPress DeviceInfo func: ${functionName}`)
      const isSync = functionName.includes('Sync')
      if (isSync && !['getIPAddress', 'getIpAddressSync', 'getMACAddress', 'isAirPlaneMode', 'isPinOrFingerprintSet', 'getUniqueId', 'getUniqueIdSync', 'getInstanceID', 'getSerialNumber', 'getAPILevel', 'getPhoneNumber', 'getPhoneNumberSync', 'getCarrier', 'getCarrierSync'].includes(functionName)) {
        try {
          let value = DeviceInfo[functionName]()
          if (typeof value == 'object')
            value = JSON.stringify(value)
          else
            value = humanReadableSpace(value)
          if (value != 'unknown')
            body += functionName + `: ` + value + "\n"
        }
        catch (err) {
  				console.tron.log(`onContactSupportPress func ${functionName}, error: ${err.message}`);
  			}
      }
    }
    console.tron.log(`onContactSupportPress body: ${body}`)
    const emailUrl = `mailto:support@kargoe.com?subject=${encodeURIComponent(`Kargoe Support (${this.props.currUsername})`)}&body=${encodeURIComponent(body)}`
    console.tron.log(`emailUrl ${emailUrl}`)
    console.tron.log(`isEmulator ` + JSON.stringify(DeviceInfo.isEmulatorSync()))
    if (DeviceInfo.isEmulatorSync()) {
      alertView(`Cannot Send Email`, `Sending Emails does not work in the simulator`)
      return
    }
    Linking.openURL(emailUrl).catch((err) => console.tron.log(`onContactSupportPress openURL error`, err))
  }

  onFAQCellPress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'FAQ', url: FAQURL });
  }

  onPrivacyCellPress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'Privacy', url: PRIVACYURL });
  }

  onTermAndConditionPress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'Terms and Conditions', url: TERMURL });
  }

  onLicensePress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'License', url: `${Platform.OS == 'ios' ? IOSURL : ANDROIDURL}` });
  }
  
  onAboutScreenPress = () => {
    this.onAboutScreenPressCount++
    if (this.onAboutScreenPressCount > 3)
      this.resetRoute('debug', {})
    else
      this.props.navigation.navigate('about', { title: 'Settings' });
  }
  
  onCacheInfoPress = () => {
    console.tron.log(`onCacheInfoPress pressed`)
    let stats = Object.assign({}, this.api.getCacheStats())
    if (stats.updated)
      stats.updated = (new Date(stats.updated)).toLocaleTimeString()
    const details = JSON.stringify(stats).replace(',', ', ')
    Alert.alert('API Cache', details,
      [
        {text: 'Enable', onPress: () => this.api.enableCache()},
        {text: 'Disable', onPress: () => this.api.disableCache()},
        {text: 'Clear', onPress: () => {
          this.api.clearCache()
          this.api.cacheDeleteAll() // main api cache
        }},
        {text: 'Cancel', onPress: () => console.log('No Pressed'), style: 'cancel'},
      ],
      { cancelable: false }
    )
  }

  gotoPaymentOptionsScreen = () => {
    this.props.navigation.navigate('paymentOptions', {});
  }
  
  gotoEditProfileScreen = () => {
    this.props.navigation.navigate('editProfile', {});
  }
  
  gotoPushNotificationSettingScreen = () => {
    this.props.navigation.navigate('pushNotificationSetting', {});
  }
  
  gotoKargoePasswordAndTouchIDScreen = () => {
    this.props.navigation.navigate('kargoePasswordAndTouchID', {});
  }
  
  gotoKargoeCareScreen = () => {
    this.props.navigation.navigate('kargoeCare', {});
  }
  
  onDebugScreen = () => {
    // this.resetRoute('debug', {})
    this.props.navigation.navigate('debug', {});
  }

  getVersionString = () => {
    if (Platform.OS == 'web') return 'v 1.0 web'
    const { version } = ReactNativeVersion
    const rnVersion = `${version.major}.${version.minor}.${version.patch}-${version.prerelease}`
    let appVersion = VersionNumber.appVersion
    let buildVersion = VersionNumber.buildVersion
    return `v ${appVersion}.${buildVersion} (RN ${rnVersion})`
  }
  
  getVersion = (label) => {
    if (Platform.OS == 'web') 
    return (<Text  
    style={{fontSize: 14, fontFamily:Fonts.style.font.regular}}>
      web
    </Text>)

    console.tron.display({name: `settings`, preview :`ReactNativeVersion`, value: {version: ReactNativeVersion.version}})
    const { version } = ReactNativeVersion
    let rnVersion = `${version.major}.${version.minor}.${version.patch}`
    if (version.prerelease)
      rnVersion += `-${version.prerelease}`
    if (__DEV__)
      rnVersion += ` DEV`
    let appVersion = VersionNumber.appVersion
    let buildVersion = VersionNumber.buildVersion
    // return `v ${appVersion}.${buildVersion} (RN ${rnVersion})`
    return (
      <Text>
        <Text style={{fontSize: 14, fontFamily:Fonts.style.font.regular}}>{`${label} v${appVersion}.${buildVersion}`}</Text>
        <Text style={{fontSize: 14, fontFamily:Fonts.style.font.regular, color: '#ccc'}}>{` (RN ${rnVersion})`}</Text>
      </Text>
    )
  }
  
  checkPlatform = () => {
    if (Platform.OS === 'ios') {
      return I18n.t('setting.agreementIOS')
    } else {
      return 'Android Software License Agreement'
    }
  }
  
  logout = () => {
    setTimeout(() => {
      this.api.cacheDeleteAll() // selective cache
      I18n.locale = getDeviceLanguage()
      PostWallBase.clearDataCache() // xhr stuff / wall
      this.api.clearCache() // main offline api cache
    }, 10)
    this.props.logout()
  }
  
  static navigationOptions = {
    header: null
  }

  componentDidMount ( ) {
    // if (this.props.canGoBack)
    if (this.props.navigation.state.params.doLogout) {
      setTimeout(() => {this.logout()}, 5000)
      return
    }
    this.navigationBar.setLeftNavBarButtons([ { onPress: this.goBackPress, type: 'back' } ])
    this.navigationBar.setRightNavBarButtons([ { onPress: this.onHomePress, type: 'home' } ])
    this.props.readUser(this.props.currUserId)
  }

  goBackPress = () => {
    // special case. we use Settings Screen to clear out the navigation stack, so our back button takes us to
    // the only place that can call this screen, the profile page
    // this.props.navigation.goBack()
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'profilewallv2', params: { userId: this.props.currUserId, username: this.props.currUsername, postId : null } })]
    }))
  }

  onHomePress = ( ) => {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
    }))
  }

  onClearCachePress = ( ) => {
    OfflineMessaging.clear()
  }
  
  onAvatarSetupTest = () => {
    setTimeout(() => {
      this.props.navigation.dispatch(NavigationActions.reset({
          index: 0,
          key: null,
          actions: [NavigationActions.navigate({ routeName: 'profileSetup' })]
      }))
    }, 1)
  }

  onBioSetupTest = () => {
    setTimeout(() => {
      this.props.navigation.dispatch(NavigationActions.reset({
          index: 0,
          key: null,
          actions: [NavigationActions.navigate({ routeName: 'bioSetup' })]
      }))
    }, 1)
  }

  inviteFriend = () => {
    if (Platform.OS != 'web') {
    console.tron.display({name: `inviteFriend`, preview :``, value: {state: this.state}})
    this.props.navigation.navigate('inviteFriend', {});
    } else {
      alert("To directly invite friends to Kargoe by text message, get the Kargoe app on the iPhone or Android app store, or just send them the link of this web site!")
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    console.tron.display({name: `componentDidUpdate`, preview :``, value: {state: this.state, thisProps: this.props, propsUser: this.props.user}})
    // bug in UserSagas/UserRedux, 'fetch' is left as 'true' somewhere...
    if (!this.props.user.error && !this.props.user.updating && this.props.user.userId == this.state.UserId && this.props.user.user && this.props.user.user.ApplicationOptions != this.state.ApplicationOptions) {
      console.tron.log(`componentDidUpdate setting ApplicationOptions to ${this.props.user.user.ApplicationOptions}`)
      this.setState({ ApplicationOptions: this.props.user.user.ApplicationOptions })
    }
  }

  setApplicationOptions = (value) => {
    console.tron.log(`setApplicationOptions: ${value}`)
    let original = this.state.ApplicationOptions,
      changes = {
        UserId: this.props.currUserId,
        ApplicationOptions: value
      },
      resolve = null,
/*
      (resp) => {
        if (resp.data && resp.data.data) {
          let user = resp.data.data[0]
          this.setState({ ApplicationOptions: user.ApplicationOptions })
        }
      },
*/      
      reject = null // () => { this.setState({ ApplicationOptions: original }) }
    this.setState({ ApplicationOptions: value }) // assume it works, will be fixed in componentDidUpdate
    this.props.updateUser({ changes, resolve, reject })
  }

  onSelectLanguage = (id) => {
    const changes = {
      UserId: this.props.currUserId,
      Language: id
    };
    I18n.locale = id
    this.props.updateUser({ changes })
    if (Platform.OS != 'web')
    userDefaults.set("kargoeLanguageFromSettingsScreen", id)
    .then(data => console.log("save ud success:  language " + JSON.stringify(data)))   // Save success
  }

  onSelectCurrency = (id) => {
    const changes = {
      UserId: this.props.currUserId,
      Currency: id
    }
    this.props.updateUser({ changes })
  }

  onToggle = (flag, state) => {
    let value = this.state.ApplicationOptions ^ flag
    this.setApplicationOptions(value)
  }

  toggleLangModal = () => {
    if (this.langSelector) {
      this.langSelector.toggleModal();
    }
  }

  toggleCurrencyModal = () => {
    if (this.currencySelector) {
      this.currencySelector.toggleModal();
    }
  }

  getSelectedLang = () => {
    const { user: { user } } = this.props
    if (!user) return

    let selectedLang = { Index: 0 }
    forEach(LANG_SELECTOR, ({ Index, Id }) => {
      if (user.Language === Id || getLanguageCode(I18n.locale) === Id) {
        selectedLang = { Index }
      }
    })
    return selectedLang
  }
  // translate currency array to language
  translateCurrencyArray = ( ) => {
    let out = []
    forEach(CURRENCY_SELECTOR, (x) => {
      let key = 'currency.' + x.Title
      let translated = I18n.t(key)
      let mutable = JSON.parse(JSON.stringify(x))
      mutable.Title = translated
      out.push(mutable)
    })
    //console.log("translated currencies " + JSON.stringify(out))
    return out
  }

  getSelectedCurrency = () => {
    const { user: { user } } = this.props;
    if (!user) return;

    let selectedCurrency = { Index: 0 }
    let translated = this.translateCurrencyArray( )

    forEach(translated, ({ Index, Id }) => {
      if (user.Currency === Id) {
        selectedCurrency = { Index }
      }
    })
    return selectedCurrency
  }

  render() {
    if (this.props.navigation.state.params.doLogout)
      return (
        <View style={{flex: 1}}>
          <Image source={Images.loginBackground}
                 style={{ width : screenWidth, height : screenHeight
                        , position : 'absolute', zIndex : -1, top : 0, left : 0 }}
                 resizeMode='cover' />
           <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
             <Text style={{color: 'white', fontFamily:Fonts.style.font.bold, fontSize: 30, textAlign: 'center'}}>{`Session has expired.  Logging Out...`}</Text>
           </View>
        </View>
      )

    let translatedCurrencies = this.translateCurrencyArray( )
    let textFieldHeight = 35
    
    let cacheInfoRow = null
    let fontViews = null
    let debugView = null
    if (__DEV__) {
      let fontFamilies = [
        ['thin', Fonts.style.font.thin],
        ['light', Fonts.style.font.light],
        ['regular', Fonts.style.font.regular],
        ['italicBold', Fonts.style.font.italicBold],
        ['semiBold', Fonts.style.font.semiBold],
        ['bold', Fonts.style.font.bold],
        ['extraBold', Fonts.style.font.extraBold],
      ]
      fontViews = []
      fontViews.push(<Text style={{fontSize: 16, fontFamily: Fonts.style.font.regular}}>{`Development Application Font Mapping`}</Text>)
      for (let fontIndex = 0; fontIndex < fontFamilies.length; fontIndex++) {
        let localName = fontFamilies[fontIndex][0]
        let systemName = fontFamilies[fontIndex][1]
        fontViews.push(
          <Text style={{fontSize: 11, fontFamily: systemName}}>{localName + ': ' + systemName}</Text>
        )
      }
      fontViews.push(<Text>{` `}</Text>)
      fontViews.push(<Text style={{fontSize: 16, fontFamily: Fonts.style.font.regular}}>{`Development Application Font Test`}</Text>)

      for (fontSize = 8; fontSize < 15; fontSize++) {
        for (let fontIndex = 0; fontIndex < fontFamilies.length; fontIndex++) {
          let localName = fontFamilies[fontIndex][0]
          let systemName = fontFamilies[fontIndex][1]
          fontViews.push(
            <Text style={{fontSize: fontSize, fontFamily: systemName}}>{fontSize + ' The Quick Brown Fox 12345 m h d (' + localName + ')'}</Text>
          )
        }
        fontViews.push(
          <Text style={{fontSize: fontSize, fontFamily: Fonts.style.font.regular}}>{`dedicating more time to my art again, have been stuck with a project`}</Text>
        )
        fontViews.push(<Text>{` `}</Text>)
      }
      fontViews.push(<View></View>)
      fontViews = (<View style={{padding: 8}}>{fontViews}</View>)
      // fontView = (<Text>Test</Text>)
      cacheInfoRow = (
        <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onCacheInfoPress}>
          {`API Cache`}
        </ListItemArrowIcon>
      )
			
    }
    
    /*
    debugView = (
      <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} onCellPress={this.onDebugScreen} text={`DEBUG only options - caution`} >
      </ListItemTextIcon >
    )

    console.log("debugView is " + debugView)
    */
   
    const isWeb = Platform.OS == 'web'
    return (
      <BaseScreen darkStatusbar loading={this.props.fetching}>
        <MainNavBarScreen
          ref={(view) => {
            if (view) this.navigationBar = view
          }}
          title={I18n.t('setting.title')}
        />
        <ScrollView style={ {backgroundColor: '#FFF'} } >

          <SectionHeaderSettings style={[styles.normalText]} text={I18n.t('setting.follow')} />
          {true && <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} text={I18n.t('setting.invite')} onCellPress={this.inviteFriend} />}

          <SectionHeaderSettings style= {styles.normalText} text={I18n.t('setting.account')} />
          
          {false && <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} text={I18n.t('setting.appLanguage')} onCellPress={this.toggleLangModal}>
            <KargoeSelectorComponent
              ref={node => this.langSelector = node}
              wrapperStyle={{ margin: 0, alignItems: 'flex-end' }}
              inputStyle={{ borderWidth: 0 }}
              width={200}
              height={textFieldHeight}
              options={LANG_SELECTOR}
              onSelect={ (json) => {
                const { Title, Index, Id } = json
                this.onSelectLanguage( Id )
              } }
              red={false}
              chevron={false}
              selected={this.getSelectedLang()}
            />
          </ListItemTextIcon >}
          
          {true && <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} text={I18n.t('setting.currency')} onCellPress={this.toggleCurrencyModal}>
            <KargoeSelectorComponent
              ref={node => this.currencySelector = node}
              wrapperStyle={{ margin: 0, alignItems: 'flex-end' }}
              inputStyle={{ borderWidth: 0 }}
              width={200}
              height={20}
              itemHeight={30}
              options={/*CURRENCY_SELECTOR*/translatedCurrencies}
              onSelect={ (json) => {
                const { Title, Index, Id } = json
                this.onSelectCurrency( Id )
              } }
              red={false}
              chevron={false}
              selected={this.getSelectedCurrency()}
            />
          </ListItemTextIcon >}

          {false &&
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} text={I18n.t('setting.passwordTouch')} onCellPress={this.gotoKargoePasswordAndTouchIDScreen} >
            <SvgTouchId size="30" />
          </ListItemTextIcon >
          }

          {false && 
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} text={I18n.t('setting.paypalEmail')} onCellPress={this.gotoPaymentOptionsScreen}>
            <Image style={{ width: textFieldHeight, height: textFieldHeight }} source={Images.paypal} />
          </ListItemTextIcon>
          }

          {false &&
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} backgroundColor='#b6cdf2' text={I18n.t('setting.kcare')} onCellPress={this.gotoKargoeCareScreen}>
            <SvgKargoeCare size="30" />
          </ListItemTextIcon >
          }

          {false && 
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} onCellPress={this.gotoEditProfileScreen} text={I18n.t('setting.editProflie')} >
            <SvgEditProfile size="30" />
          </ListItemTextIcon >
          }

          {false && 
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} onCellPress={this.onDeliveryCellPress} text={I18n.t('setting.deliAddress')}>
            <SvgDelivery size="40" />
          </ListItemTextIcon >          
          }

          {false &&
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} onCellPress={this.gotoPushNotificationSettingScreen} text={I18n.t('setting.pushNotifi')} >
            <SvgPush size="30" />
          </ListItemTextIcon >
          }

          {false &&
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight, flex: 1}} borderBottomWidth={0} text={I18n.t('setting.transPanel')} >
            <View style={{ alignItems: 'center' }}>
              <Switch onValueChange={() => this.onToggle(1)} value={this.state.ApplicationOptions & 1 ? true : false} />
            </View>
          </ListItemTextIcon >
          }

          {false && 
          <ListItemTextIcon extraTextStyle={{height : textFieldHeight, flex: 1}} borderBottomWidth={0} text={I18n.t('setting.slowNetwork')} >
            <View style={{ alignItems: 'center' }}>
              <Switch onValueChange={() => this.onToggle(2)} value={this.state.ApplicationOptions & 2 ? true : false} />
            </View>
          </ListItemTextIcon >
          }
          
          <SectionHeaderSettings style= {styles.normalText} text={I18n.t('setting.help')} />
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onContactSupportPress} text={I18n.t('setting.contact')} />
          
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onFAQCellPress} text={I18n.t('setting.faq')} />
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onPrivacyCellPress} text={I18n.t('setting.privacy')} />
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onLicensePress} text={this.checkPlatform()} />
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onTermAndConditionPress} text={I18n.t('setting.termCondition')} />
          {cacheInfoRow}
          {false &&
          <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} withArrow onCellPress={this.onAboutScreenPress}>
            {isWeb ? 'web development version' : this.getVersion(I18n.t('setting.about'))}
          </ListItemArrowIcon>
          }
          <ListItemTextMiddle isBoldText onPress={this.logout} text={I18n.t('setting.logout')} backgroundColor="#B21E25"/>
          {!isWeb && <ListItemArrowIcon extraTextStyle={{height : textFieldHeight}} borderBottomWidth={0} onCellPress={this.onClearCachePress} text={I18n.t('setting.clearCache')} />}

          {!isWeb && <View>
          {debugView}
          {fontViews}
          <ListItemTextMiddle text={''} />

          </View>}
        </ScrollView >
      </BaseScreen>
    )
    // <ListItemArrowIcon borderBottomWidth={0} onCellPress={this.onAvatarSetupTest} text={'Avatar Setup Test'} />
    // <ListItemArrowIcon borderBottomWidth={0} withArrow onCellPress={this.onAboutScreenPress} text={`About Kargoe ${this.getVersion()}`} />
  }
}

const mapStateToProps = (state) => {
  return {
    currUserId: state.auth.user ? state.auth.user.UserId : null,
    currUsername: state.auth.user ? state.auth.user.Username : null,
    token : state.auth.token,
    fetching: state.auth.fetching,
    currency: state.auth.user ? state.auth.user.Currency : null,
    user: state.user,
    canGoBack: state.nav.routes.length > 1,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(AuthActions.logoutRequest()),
    readUser: UserId => dispatch(UserActions.readRequest(UserId)),
    updateUser: changes => dispatch(UserActions.updateRequest(changes)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsScreen)
